module.exports = __webpack_public_path__ + "img/example-teacher-parent-meeting.e99100c0.jpg";